import React, {useRef, useContext, useCallback } from 'react';
import { copyToClipboard } from '../helpers';

import {ModalContext} from "../context/ModalContext";

const objectMap = {
  task_count: 'Task',
  user_count: 'User',
  user_group_count: 'User Group',
}

// Stable per-dialog id for React keys in ModalDialog's layer stack — needs
// to survive across pause/resume, so a function reference isn't enough
// (see showModalDialog's stacking comment).
let nextDialogId = 0

export const useModalDialog = () => {

  let {
    modalDialog,
    setModalDialog,
    modalStack,
    setModalStack,
    loadingModalDialog,
    setLoadingModalDialog,
    show,
    setShow
  } = useContext(ModalContext);

  const refContainerBody = useRef()

  const renderCheckDeleteBody = (checkDelete) => {
    return  <div>
              <div>Are you sure you want to delete the following items?</div>
              <ul>
              { Object.keys(checkDelete.result).map( (key, index) => {
                    return checkDelete.result[key] > 0  
                            ? <li key={key}>{checkDelete.result[key] + ' ' + objectMap[key] + (checkDelete.result[key] > 1 ? 's':'')}</li> 
                            : null
                })
              }
              </ul>
            </div>
  }

  // Opening a dialog while one is already showing pushes the current one
  // onto modalStack instead of discarding it — hideModalDialog pops back to
  // it (e.g. "Nytt företag" opened from inside "Ny person"). Pass
  // stack:false to replace the current dialog outright instead (rare).
  const showModalDialog = useCallback(
    ({title, Content, contentProps, submitLabel, submitLabelLoading, cancelLabel, onSubmit, onCancel, customButtons, loading, stack = true}) => {

      let config = {
            id: ++nextDialogId,
            Content,
            contentProps,
            title: title || "You are about to delete some stuff",
            cancelLabel: cancelLabel !== undefined ? cancelLabel : "Cancel",
            submitLabel: submitLabel !== undefined ? submitLabel : "OK",
            submitLabelLoading: submitLabelLoading ? submitLabelLoading : submitLabel || "OK",
            onSubmit: (data) => {onSubmit !== undefined ? onSubmit(data) : hideModalDialog()},
            onCancel: onCancel !== undefined ? onCancel : hideModalDialog,
            customButtons: customButtons
      }

      if (stack && show && modalDialog && Object.keys(modalDialog).length > 0) {
        setModalStack(prev => [...prev, modalDialog])
      }

      setLoadingModalDialog(prev => loading || false)
      setShow(prev => true)
      setModalDialog({...config})

    }, [show, modalDialog]) // eslint-disable-line react-hooks/exhaustive-deps

  // Pops back to the paused dialog underneath (if any) instead of closing
  // everything — see showModalDialog's stacking comment.
  const hideModalDialog = useCallback(
    (props) => {
      setModalStack(prevStack => {
        if (prevStack.length > 0) {
          setModalDialog(prevStack[prevStack.length - 1])
          setShow(true)
          return prevStack.slice(0, -1)
        }
        setModalDialog({})
        setShow(false)
        return prevStack
      })
    },
    []
  );


  return {
    showModalDialog,
    hideModalDialog,
    show,
    loadingModalDialog,
    setLoadingModalDialog,
    modalDialog,
    setModalDialog,
    modalStack,
    setModalStack,
    renderCheckDeleteBody
  }
};